export enum StaffType {
	SIL = 1,
	SP = 2
}
